import emptyCartState from 'features/cart/ducks/state'
import {
  paymentInitRoutine,
  checkBasketAvailabilityRoutine,
  clearBasketAvailabilityRoutine
} from 'features/cart/ducks/actions'
import { propOr } from 'ramda'

export default (state = emptyCartState, action) => {
  switch (action.type) {
    case paymentInitRoutine.REQUEST:
      return {
        ...state,
        paymentProcessing: true,
        checkoutSessionUrl: ''
      }
    case paymentInitRoutine.SUCCESS:
      return {
        ...state,
        paymentProcessing: false,
        checkoutSessionUrl: propOr('', 'payload', action)
      }
    case paymentInitRoutine.FAILURE:
      return {
        ...state,
        paymentProcessing: false
      }
    case checkBasketAvailabilityRoutine.TRIGGER:
    case checkBasketAvailabilityRoutine.REQUEST:
      return {
        ...state,
        basketAvailabilityStatus: 'loading'
      }
    case checkBasketAvailabilityRoutine.SUCCESS:
      return {
        ...state,
        cartAvailableBps: action.payload,
        basketAvailabilityStatus: 'success'
      }
    case checkBasketAvailabilityRoutine.FAILURE:
      return {
        ...state,
        basketAvailabilityStatus: 'failure'
      }
    case clearBasketAvailabilityRoutine.SUCCESS:
      return {
        ...state,
        cartAvailableBps: [],
        basketAvailabilityStatus: 'success'
      }
    default:
      return state
  }
}
